function searchEvents(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/search`;
  return apiClient.get(route, { query });
}

function getEvents(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events`;
  return apiClient.get(route, { query });
}

function getMyEvents(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations`;
  return apiClient.get(route, { query });
}

function cancelRegistration(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations/cancel`;
  return apiClient.delete(route, query);
}

function updateRegistration(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations`;
  return apiClient.put(route, query);
}

export default {
  searchEvents,
  getEvents,
  getMyEvents,
  cancelRegistration,
  updateRegistration
};
